import { useRef, useCallback } from 'react';
import { parallax } from '@immutabl3/alchemy/three';
import { PerspectiveCamera } from '@react-three/drei';
import { useAsset } from '@artica/assets';
import CameraCenterCorrection from './CameraCenterCorrection';
import {
  useSetRef,
  useManagedAnimations,
} from '@artica/hooks';

const ParallaxPerspectiveCamera = parallax(PerspectiveCamera);

export default function Camera() {
  const asset = useAsset('camera');
  const groupRef = useSetRef('landscapecamera');
  const camRef = useRef();
  const fovRef = useRef();
  const { animations } = asset;
  const { actions } = useManagedAnimations(animations, groupRef);

  const onUpdateFov = useCallback(() => {
    const camera = camRef?.current;
    const fov = fovRef?.current;
    if (!camera || !fov) return;
    const setfov = fov.position.y / 1.8;
    if (setfov === camera.getFocalLength()) return;
    camera.setFocalLength(setfov);
  }, []);
  
  const onPercChange = useCallback((perc, ref) => {
    const animation = actions?.animation_0;
    if (!animation) return;
    const mixer = animation.getMixer();
    const { duration } = animation.getClip();
    const sec = duration * perc;
    mixer.setTime(sec);
    
    const beforeLandscapePerc = 0.6 / 35;
    if (perc < beforeLandscapePerc) {
      ref.current.position.y = -75;
    }
  }, [actions]);

  return (
    <CameraCenterCorrection>
      <group ref={ groupRef }>
        <ParallaxPerspectiveCamera
          name="cam1"
          ref={ camRef }
          far={ 50000 }
          near={ 1 }
          makeDefault={ true }
          beaker="chapter1"
          onPercChange={ onPercChange }
          onTick={ onUpdateFov }
        />
        <group
          ref={ fovRef }
          name="fov_null"
        />
      </group>
    </CameraCenterCorrection>
  );
};